module.exports = __webpack_public_path__ + "static/PersonalSecret-9bdd15a886bd77e843025a517f454003.png";